// src/services/api.js
import axios from 'axios';

const api = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}/api`,
});

// Fonctions pour les factures
export const fetchInvoices = () => api.get('/invoices');
export const createInvoice = (invoice) => api.post('/invoices', invoice);
export const updateInvoice = (id, invoice) => api.put(`/invoices/${id}`, invoice);
export const deleteInvoice = (id) => api.delete(`/invoices/${id}`);

// Fonctions pour les dépenses
export const fetchExpenses = () => api.get('/expenses');
export const createExpense = (expense) => api.post('/expenses', expense);
export const updateExpense = (id, expense) => api.put(`/expenses/${id}`, expense);
export const deleteExpense = (id) => api.delete(`/expenses/${id}`);

// Fonctions pour les transactions bancaires
export const createTransactions = (transactionsData) => api.post('/', transactionsData);
export const getAllTransactions = () => api.get('/');

// src/services/api.js
export const getAccountBalance = (account) => api.get(`/transactions/account/${account}/balance`);
export const getExpensesByCategory = (account) => api.get(`/transactions/account/${account}/categories`);
export const getTransactionsByAccount = (account) => api.get(`/transactions/account/${account}`);


// Export par défaut de l'instance axios
export default api;
